import type { CSSProperties, ReactNode } from 'react';

export type CardPadding = 'none' | 'sm' | 'md' | 'lg';

interface CardProps {
  children: ReactNode;
  padding?: CardPadding;
  interactive?: boolean;
  /** Optional override of the inner radius. Defaults to --r-3 (10px). */
  radius?: number | string;
  className?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

const paddings: Record<CardPadding, number> = {
  none: 0,
  sm: 12,
  md: 16,
  lg: 24,
};

export default function Card({
  children,
  padding = 'md',
  interactive = false,
  radius,
  className,
  style,
  onClick,
}: CardProps) {
  return (
    <div
      className={className}
      onClick={onClick}
      style={{
        background: 'var(--surface, oklch(0.11 0.012 230))',
        border: '1px solid var(--border, oklch(0.18 0.012 230))',
        borderRadius: radius ?? 'var(--r-3, 10px)',
        padding: paddings[padding],
        cursor: interactive ? 'pointer' : undefined,
        transition: interactive ? 'background 120ms ease, border-color 120ms ease' : undefined,
        ...style,
      }}
      onMouseEnter={
        interactive
          ? (e) => {
              e.currentTarget.style.background = 'var(--surface-2, oklch(0.14 0.012 230))';
              e.currentTarget.style.borderColor = 'var(--border-strong, oklch(0.24 0.010 230))';
            }
          : undefined
      }
      onMouseLeave={
        interactive
          ? (e) => {
              e.currentTarget.style.background = 'var(--surface, oklch(0.11 0.012 230))';
              e.currentTarget.style.borderColor = 'var(--border, oklch(0.18 0.012 230))';
            }
          : undefined
      }
    >
      {children}
    </div>
  );
}
